import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import LayerActiveIcon from "assets/images/layer-active-icon.png";
import "./index.scss";


function formatDateTime(date) {
    const dateOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    };
    const timeOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
    return `${formattedDate}, ${formattedTime}`;
}
const fixedTemploValue = (i) => `00${Math.floor(i)}`.slice(-3);


const LayerInfo = ({ data, onClose }) => {
    return (
        <Box className="layer-info-wrapper">
            <Box className="top-box">
                <Box className="title">
                    {data?.title}
                </Box>
                <img src={LayerActiveIcon} alt="layer icon" className="icon" />
            </Box>
            <List className="details">
                <ListItem className="item-detail">
                    <Box className="title">
                        File Name
                    </Box>
                    <Box className="value">
                        {data.file.name.split('.').slice(0, -1).join('.')}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Type of file
                    </Box>
                    <Box className="value">
                        {data.file.type.split('/')[1]}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Size
                    </Box>
                    <Box className="value">
                        {Math.floor(data.file.size / 1000000)} MB
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Length
                    </Box>
                    <Box className="value">
                        {data.length}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Created
                    </Box>
                    <Box className="value">
                        {formatDateTime(data.created)}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Modified
                    </Box>
                    <Box className="value">
                        {formatDateTime(data.file.lastModifiedDate)}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Tempo
                    </Box>
                    <Box className="value">
                        {fixedTemploValue(data.tempo)}
                    </Box>
                </ListItem>
            </List>
            <Box className="actions">
                <button className="cancel" onClick={onClose}>Close</button>
            </Box>
        </Box>
    )
}

export default LayerInfo